import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { StyledGrid, StyledOptionWrapper } from './OptionPicker.style';
import { Text } from '../../ui/Text';
const variants = ['grid'];
export function OptionPicker({ variant = 'grid', options, onClick, }) {
    var _a;
    const [selectedOption, setSelectedOption] = useState((_a = options.find((option) => option.isSelected)) === null || _a === void 0 ? void 0 : _a.value);
    const onClickHandler = (option) => {
        setSelectedOption(option.value);
        onClick === null || onClick === void 0 ? void 0 : onClick(option);
    };
    return (_jsx(StyledGrid, { children: options.map((option, index) => {
            return (_jsx(StyledOptionWrapper, { isSelected: selectedOption === option.value, onClick: () => onClickHandler(option), children: _jsx(Text, { size: 'Small', children: option.label }) }, `${option.value}-${index}`));
        }) }));
}
//# sourceMappingURL=OptionPicker.js.map